import { useEffect, useState } from "react";

const PWAModal = () => {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [showModal, setShowModal] = useState(true);
  const [isiOS, setIsiOS] = useState(false);

  useEffect(() => {
    const isStandalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      (window.navigator as any).standalone === true;
  
    if (isStandalone) {
      // Already running as PWA — no need to show modal
      setShowModal(false);
      return;
    }
  
    const handler = (e: Event) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowModal(true);
    };
  
    window.addEventListener("beforeinstallprompt", handler as EventListener);
  
    // Detect iOS non-standalone
    const isIOSDevice =
      /iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase()) &&
      !(window.navigator as any).standalone;
  
    if (isIOSDevice) {
      setIsiOS(true);
      setShowModal(true);
    }
  
    return () => {
      window.removeEventListener("beforeinstallprompt", handler as EventListener);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const result = await deferredPrompt.userChoice;

    if (result.outcome === "accepted") {
      console.log("PWA install accepted");
    } else {
      console.log("PWA install dismissed");
    }

    setDeferredPrompt(null);
    setShowModal(false);
  };

  if (!showModal) return null;

  return (
    <div className="modal show d-block" tabIndex={-1} role="dialog">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content shadow">
          <div className="modal-header">
            <h5 className="modal-title">Install this app</h5>
            <button
              type="button"
              className="btn-close"
              onClick={() => setShowModal(false)}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            {isiOS ? (
              <div>
                <p>This app can be added to your home screen for a full experience.</p>
                <ol>
                  <li>Tap the <strong>Share</strong> icon in Safari</li>
                  <li>Select <strong>Add to Home Screen</strong></li>
                </ol>
              </div>
            ) : deferredPrompt ? (
              <p>Install this app on your device for quicker access and offline use.</p>
            ) : (
              <ol>
                <li>Tap the <strong>Share</strong> icon in your browser</li>
                <li>Select <strong>Add to Home Screen</strong></li>
              </ol>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowModal(false)}
            >
              Close
            </button>
            {deferredPrompt && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleInstallClick}
              >
                Install
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PWAModal;